import axios from "axios";
import { AxiosError } from "axios";
import { Dispatch } from "redux";
import { Action } from "api/action_types/signature";
import { Action as OrderAction } from "api/action_types/order";
import { Action as QuoteAction } from "api/action_types/quote";
import { Action as SelfOrderAction } from "api/action_types/self_order";
import { Action as SketchAction } from "api/action_types/sketch";
import { ActionType } from "api/action_types/signature";
import { ActionType as SelfOrderActionType } from "api/action_types/self_order";
import { url_prefix } from "settings";
import { self_order_signature_url } from "../../endpoint";

export const getSelfOrderSignature = (signature_key: string) => {
  return async (dispatch: Dispatch<Action | OrderAction | QuoteAction | SelfOrderAction | SketchAction>) => {
    dispatch({
      type: ActionType.SIGNATURE_LOADING
    });

    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    }

    const url = `${url_prefix}${self_order_signature_url}/0/?signature_key=${signature_key}`;

    try {
      const { data } = await axios.get(url, config);

      if (data.id) {
        dispatch({
          type: ActionType.GET_SIGNATURE_SUCCESS,
          signature: data.signature
        });

        dispatch({
          type: SelfOrderActionType.GET_SELF_ORDER_SUCCESS,
          self_order: data.self_order
        });

        dispatch({
          type: SelfOrderActionType.GET_SELF_ORDER_COUNTERS_SUCCESS,
          self_order_counters: data.counters
        });

        dispatch({
          type: SelfOrderActionType.GET_SELF_ORDER_AREAS_SUCCESS,
          self_order_areas: data.areas
        });

        dispatch({
          type: SelfOrderActionType.GET_SELF_ORDER_SLABS_SUCCESS,
          self_order_slabs: data.slabs
        });

        dispatch({
          type: SelfOrderActionType.GET_SELF_ORDER_VENDOR_SUCCESS,
          vendor: data.vendor
        });
      }
      else {
        dispatch({
          type: ActionType.ALREADY_SIGNED
        });
      }
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.SIGNATURE_ERROR,
          error: err.message
        });
      }
    }
  }
}
